module.exports = __webpack_public_path__ + "08ad4d7e40604d5c934501dc6720bdb9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/truck.png
// module id = 2629
// module chunks = 0